import React, {createContext, useState, useCallback, useRef, useEffect} from 'react';
import {useLessonPlaybackState} from "../hooks/useLessonPlaybackState";
import useEmitterListener from "../hooks/useEmitterListener";

const LessonNavigationContext = createContext();

function LessonNavigationProvider({
                                step, // Legacy prop - used by exercises.js to advance or reverse the lesson step
                                children,
                                sectionIndex,
                                subSectionIndex,
                                sectionsTotal,
                                subSectionTotal,
                                isUserInteractionRequired,
                            }) {

    const [keepPlaying, setKeepPlaying] = useState(true);
    const [keepPlayingDelay, setKeepPlayingDelay] = useState(1000);
    const timeoutId = useRef(null);
    const { reset, on, off } = useLessonPlaybackState();

    const next = useCallback(() => {
        reset(`${sectionIndex}-${subSectionIndex}`); // Use section and subsection indices as activityId

        //TODO move the entire logic from exercises.js to here
        step("forward", true);
    }, [sectionIndex, subSectionIndex, sectionsTotal, subSectionTotal, reset]);

    const back = useCallback(() => {
        reset(`${sectionIndex}-${subSectionIndex}`); // Use section and subsection indices as activityId

        //TODO move the entire logic from exercises.js to here
        step("backward", true);
    }, [sectionIndex, subSectionIndex, subSectionTotal, reset]);

    const goTo = useCallback((sectionIndex, subsectionIndex) => {
        reset(`${sectionIndex}-${subSectionIndex}`); // Use section and subsection indices as activityId

    }, [sectionsTotal, subSectionTotal, reset]);

    const handleActivityFinished = useEmitterListener(() => {
        if (keepPlaying && !isUserInteractionRequired()) {
            timeoutId.current = setTimeout(next, keepPlayingDelay);
        }
    }, [keepPlaying, keepPlayingDelay, next]);

    const clearNextTimeout = useCallback(() => {
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
            timeoutId.current = null;
        }
    }, []);

    // TODO remove this side-effect, the templates should call the handleActivityFinished event, so this context
    // work with declarative approach rather than relying on LessonPlaybackState side effects.
    useEffect(() => {
        //Register listener on the first execution
        on('finished', handleActivityFinished);

        return () => {
            //Unregister listener on cleanup
            off('finished', handleActivityFinished);
        }
    }, []);

    const value = {
        next,
        back,
        goTo,
        keepPlaying,
        setKeepPlaying,
        keepPlayingDelay,
        setKeepPlayingDelay,
        handleActivityFinished,
        clearNextTimeout,
        sectionIndex,
        subSectionIndex,
        sectionsTotal,
        subSectionTotal
    };

    return (
        <LessonNavigationContext.Provider value={value}>
            {children}
        </LessonNavigationContext.Provider>
    );
}


export { LessonNavigationProvider, LessonNavigationContext };